<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal-user-preferences modal fade in">
    <div class="backdrop"></div>
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    (click)="closeDialog()"
                    class="close">
                    <i class="nlrp-icon nlrp-icon-close"></i
                ></button>
                <h4 class="modal-title">Preferences</h4>
            </div>
            <div class="userp-body">
                <div class="body-content">
                    <div class="tabbable">
                        <div
                            class="content-category col-xs-2"
                            data-toggle="buttons">
                            @for (userPrefsCategoryLookup of userPrefsCategoryLookups; track userPrefsCategoryLookup) {
                                <ul
                                    class="nav nav-tabs content-tabs"
                                    role="tablist">
                                    <li
                                        role="presentation"
                                        class="category-tab active">
                                        <a
                                            href
                                            data-target="#constructionTab"
                                            aria-controls="constructionTab"
                                            role="tab"
                                            data-toggle="tab"
                                            title="{{userPrefsCategoryLookup.tooltip}}">
                                            <i class="nlrp-icon">{{userPrefsCategoryLookup.icon}} </i>{{userPrefsCategoryLookup.label}}
                                        </a>
                                    </li>
                                </ul>
                            }
                        </div>
                        <div class="content-details col-xs-4">
                            <div
                                class="tab-pane active"
                                id="constructionTab">
                                <div>
                                    <i class="nlrp-icon nlrp-icon-construct-features"></i>
                                    <span>{{userPrefsCategoryLookups[0].headingLabel}}</span>
                                </div>

                                <div class="construction-tool-preferences">
                                    <h6 title="{{userPrefsGroupLookups[0].tooltip}}">
                                        <i class="nlrp-icon nlrp-icon-display-mode pd-icon"></i>
                                        <strong>{{userPrefsGroupLookups[0].label}}</strong>
                                    </h6>
                                    <div>
                                        <i
                                            (click)="clickDisplay()"
                                            class="nlrp-icon"
                                            title="{{userPrefsAttrsLookups[0].tooltip}}"
                                            [ngClass]="{'nlrp-icon-check-box-selected': display, 'nlrp-icon-check-box-unselected': !display}"></i>
                                        <span title="{{userPrefsAttrsLookups[0].tooltip}}">{{userPrefsAttrsLookups[0].label}}</span>
                                    </div>
                                </div>

                                <div class="merge-lines-tool-preferences">
                                    <h6 title="{{userPrefsGroupLookups[1].tooltip}}">
                                        <i class="nlrp-icon nlrp-icon-merge-lines pd-icon"></i>
                                        <strong>{{userPrefsGroupLookups[1].label}}</strong>
                                    </h6>
                                    <div title="{{userPrefsAttrsLookups[1].tooltip}}">
                                        <span>{{userPrefsAttrsLookups[1].label}}</span>
                                        @for (option of mergeLinesViewOptions; track option; let optionIndex = $index) {
                                            <label
                                                class="nlr-radio"
                                                title="{{option.tooltip}}">
                                                <input
                                                    type="radio"
                                                    [value]="option.value"
                                                    [(ngModel)]="mergeLinesTypeSelected" />
                                                <span>{{option.label}}</span>
                                            </label>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-default nlr-btn-sm"
                    (click)="saveUserPreferences()"
                    >Save
                </button>
                <button
                    type="button"
                    class="btn btn-default nlr-btn-sm"
                    (click)="closeDialog()"
                    >Close
                </button>
            </div>
        </div>
    </div>
</div>
